musicManager = {};

musicManager.hasInitialised = false;

musicManager._MAX_MUSIC_VOL = 1;
musicManager._LOWERED_MUSIC_VOL = 0.5;
musicManager._fadeBaseTimeIn = 1000;
musicManager._fadeBaseTimeOut = 2000;
musicManager._returnIdleTime = 6;

musicManager._baseMusic = ['baseIdle', 'baseTheme', 'basePowerReadyTheme'];
musicManager._baseIDs = [];

musicManager._powerMusic = ['powerTheme'];
musicManager._powerIDs = [];

musicManager._shuffleMusic = ['shuffleTheme1', 'shuffleTheme2', 'shuffleTheme3', 'shuffleTheme4'];
musicManager._shuffleIDs = [];

musicManager._BASE_ALL_OFF = [false, false, false];
musicManager._BASE_IDLE = [true, false, false];
musicManager._BASE_LVL1 = [false, true, false];
musicManager._BASE_POWER_READY = [false, false, true];

musicManager._POWER_ALL_OFF = [false];
musicManager._POWER_LVL1 = [true];

musicManager._SHUFFLE_ALL_OFF = [false, false, false, false];
musicManager._SHUFFLE_LVL1 = [true, false, false, false];
musicManager._SHUFFLE_LVL2 = [false, true, false, false];
musicManager._SHUFFLE_LVL3 = [false, false, true, false];
musicManager._SHUFFLE_LVL4 = [false, false, false, true];

musicManager._basePlaying = musicManager._BASE_ALL_OFF;

musicManager._powerPlaying = musicManager._POWER_ALL_OFF;

musicManager._shufflePlaying = musicManager._SHUFFLE_ALL_OFF;

musicManager._returnIdleTimer = undefined;

musicManager._soundsToFadeOut = [];
musicManager._soundsToFadeIn = [];
musicManager._soundsToFadeInPower = [];
musicManager._soundsToFadeOutPower = [];
musicManager._soundsToFadeInShuffle = [];
musicManager._soundsToFadeOutShuffle = [];

musicManager._fadeInActive = false;
musicManager._fadeOutActive = false;
musicManager._fadeInActivePower = false;
musicManager._fadeOutActivePower = false;
musicManager._fadeInActiveShuffle = false;
musicManager._fadeOutActiveShuffle = false;

musicManager._fadeInTimer = undefined;
musicManager._fadeOutTimer = undefined;
musicManager._fadeInTimerPower = undefined;
musicManager._fadeOutTimerPower = undefined;
musicManager._fadeInTimerShuffle = undefined;
musicManager._fadeOutTimerShuffle = undefined;

musicManager._idle = true;
musicManager._playing = false;
musicManager._inXtraPowerReady = false;
musicManager._inPower = false;
musicManager._inShuffle = false;

musicManager._shuffleLvl = 1;

musicManager.initialise = function () {};

musicManager.onGameLoaded = function (onGameStart = false) {
  if (musicManager.hasInitialised) {
    return;
  }

  for (let i = 0; i < musicManager._baseMusic.length; i++) {
    musicManager._baseIDs.push(soundManager.play(musicManager._baseMusic[i]));
    soundManager.setVolume(0, musicManager._baseIDs[i]);
  }

  for (let i = 0; i < musicManager._powerMusic.length; i++) {
    musicManager._powerIDs.push(soundManager.play(musicManager._powerMusic[i]));
    soundManager.setVolume(0, musicManager._powerIDs[i]);
  }

  for (let i = 0; i < musicManager._shuffleMusic.length; i++) {
    musicManager._shuffleIDs.push(soundManager.play(musicManager._shuffleMusic[i]));
    soundManager.setVolume(0, musicManager._shuffleIDs[i]);
  }

  if (!onGameStart) {
    musicManager.fadeLevels(musicManager._BASE_IDLE, 0, 0, musicManager._MAX_MUSIC_VOL, 0);
  }
  musicManager.hasInitialised = true;
};

musicManager.onGameStart = function () {
  if (!musicManager.hasInitialised) {
    musicManager.onGameLoaded(true);
  }

  musicManager._idle = false;

  if (!musicManager._playing && !musicManager._inPower && !musicManager._inXtraPowerReady) {
    musicManager._playing = true;
    musicManager.fadeLevels(musicManager._BASE_LVL1, 300, 500, musicManager._MAX_MUSIC_VOL, 0);
  }
};

musicManager.onGameEnd = function () {
  if (!musicManager._inXtraPowerReady) {
    musicManager._idle = true;
    musicManager._playing = false;
    if (!autoplayManager.isAutoplayEnabled() || autoplayManager.getRemainingRounds() <= 0) {
      musicManager._returnIdleTimer = gsap.delayedCall(musicManager._returnIdleTime, () => {
        musicManager.fadeLevels(musicManager._BASE_IDLE, 1500, 2000, musicManager._MAX_MUSIC_VOL, 0);
      });
    }
  }
};

musicManager.onXtraPowerReady = function () {
  musicManager.fadeLevels(
    musicManager._BASE_POWER_READY,
    musicManager._fadeBaseTimeIn,
    musicManager._fadeBaseTimeOut,
    musicManager._MAX_MUSIC_VOL,
    0
  );
  musicManager._inXtraPowerReady = true;
};


musicManager.onXtraPowerStart = function () {
  musicManager._inXtraPowerReady = false;
  musicManager._inPower = true;

  musicManager.fadeBaseMusicOff(500);
  timerManager.addTimeout(300, () => {
    soundManager.play("powerTriggered", () => {
      musicManager.fadeLevelsPower(
        musicManager._POWER_LVL1,
        musicManager.fadeInTime,
        0,
        musicManager._MAX_MUSIC_VOL,
        0
      );
    });
  })
};

musicManager.onShuffleStart = function () {
  musicManager._inShuffle = true;

  const trailLevel = resourceManager
    .get('multiplierTrailWrapper:multiplierTrail:multiplierTrail')
    .getCurrentTotalLevel();

  musicManager.fadeBaseMusicOff(500);
  musicManager.fadeShuffleMusicLevel(trailLevel, 300);
};

musicManager.onFeatureEnd = function () {
  if (musicManager._inShuffle) {
    musicManager._inShuffle = false;
    musicManager.fadeShuffleMusicOff(0);
  } else if (musicManager._inPower) {
    musicManager._inPower = false;
    musicManager.fadePowerMusicOff(0);
  }
  soundManager.play('featureEnd', musicManager.resumeBaseMusic);
};

musicManager.fadeShuffleMusicLevel = function (trailLevel, timeIn = musicManager._fadeBaseTimeIn, timeOut = musicManager._fadeBaseTimeOut) {
  if (musicManager._inShuffle) {
    let newShuffleMusicLvl = musicManager._SHUFFLE_LVL1;
    if (trailLevel >= 6) {
      newShuffleMusicLvl = musicManager._SHUFFLE_LVL4;
    } else if (trailLevel === 5) {
      newShuffleMusicLvl = musicManager._SHUFFLE_LVL3;
    } else if (trailLevel >= 3) {
      newShuffleMusicLvl = musicManager._SHUFFLE_LVL2;
    } else {
      newShuffleMusicLvl = musicManager._SHUFFLE_LVL1;
    }

    if (musicManager._shufflePlaying != newShuffleMusicLvl) {
      musicManager.fadeLevelsShuffle(
        newShuffleMusicLvl,
        timeIn,
        timeOut,
      );
    }
  }
};

musicManager.playBonusSlideOntoTrail = function () {
  soundManager.play('bonusSlideOntoTrail');
};

musicManager.playBonusLandOnTrail = function () {
  musicManager.playRandomFromArray(['bonusLandOnTrail1', 'bonusLandOnTrail2']);
};

musicManager.onBigWinStart = function () {
  if (!musicManager._inShuffle && !musicManager._inPower) {
    musicManager.fadeBaseMusicOff(500);
  }
  if (musicManager._inPower) {
    musicManager.fadePowerMusicOff(500);
  }
  if (musicManager._inShuffle) {
    musicManager.fadeShuffleMusicOff(500);
  }
  soundManager.play('bigwin_loop');
};

musicManager.onBigWinEnd = function () {
  if (musicManager.isSoundPlaying('bigwin_loop')) {
    soundManager.stop('bigwin_loop');
    soundManager.play('bigwin_loop_end', musicManager.resumeBaseMusic);
    soundManager._bigWinTheme = undefined;
  }
};

musicManager.startCountUp = function () {
  if (!musicManager.isSoundPlaying('countup_loop')) {
    soundManager.play('countup_loop');
  }
};

musicManager.endCountUp = function () {
  if (musicManager.isSoundPlaying('countup_loop')) {
    soundManager.stop('countup_loop');
    soundManager.play('countup_loop_end');
  }
};

musicManager.decreaseCurrentTuneVolume = function () {
  let currentMusicPlaying = musicManager._basePlaying;
  let currentMusicIDs = musicManager._baseIDs;
  if (musicManager._inShuffle) {
    currentMusicPlaying = musicManager._shufflePlaying;
    currentMusicIDs = musicManager._shuffleIDs;
  } else if (musicManager._inPower) {
    currentMusicPlaying = musicManager._powerPlaying;
    currentMusicIDs = musicManager._powerIDs;
  } else {
    currentMusicPlaying = musicManager._basePlaying;
    currentMusicIDs = musicManager._baseIDs;
  }

  const idIndex = currentMusicPlaying.findIndex((isPlaying) => isPlaying === true);
  const tuneId = currentMusicIDs[idIndex];

  const volDifference = musicManager._MAX_MUSIC_VOL - musicManager._LOWERED_MUSIC_VOL;
  timerManager.addTimer(500, (progress) => {
    soundManager.setVolume(
      musicManager._MAX_MUSIC_VOL - progress * volDifference,
      tuneId
    );
  });
}

musicManager.increaseCurrentTuneVolume = function () {
  let currentMusicPlaying = musicManager._basePlaying;
  let currentMusicIDs = musicManager._baseIDs;
  if (musicManager._inShuffle) {
    currentMusicPlaying = musicManager._shufflePlaying;
    currentMusicIDs = musicManager._shuffleIDs;
  } else if (musicManager._inPower) {
    currentMusicPlaying = musicManager._powerPlaying;
    currentMusicIDs = musicManager._powerIDs;
  } else {
    currentMusicPlaying = musicManager._basePlaying;
    currentMusicIDs = musicManager._baseIDs;
  }

  const idIndex = currentMusicPlaying.findIndex((isPlaying) => isPlaying === true);
  const tuneId = currentMusicIDs[idIndex];

  const volDifference = musicManager._MAX_MUSIC_VOL - musicManager._LOWERED_MUSIC_VOL;
  timerManager.addTimer(500, (progress) => {
    soundManager.setVolume(
      musicManager._LOWERED_MUSIC_VOL + progress * volDifference,
      tuneId
    );
  });
}

musicManager.resumeBaseMusic = function () {
  if (musicManager._inXtraPowerReady) {
    musicManager.onXtraPowerReady();
  } else if (!gameController.bigWin.isBigWinActive()) {
    musicManager.fadeLevels(
      musicManager._BASE_LVL1,
      musicManager._fadeBaseTimeIn,
      musicManager._fadeBaseTimeOut,
      musicManager._MAX_MUSIC_VOL,
      0
    );

    musicManager._idle = true;
    musicManager._playing = false;
    musicManager._returnIdleTimer = gsap.delayedCall(musicManager._returnIdleTime, () => {
      musicManager.fadeLevels(musicManager._BASE_IDLE, 1500, 2000, musicManager._MAX_MUSIC_VOL, 0);
    });
  }
};

musicManager.isSoundPlaying = function (soundName) {
  const filename = soundManager.soundsConfig.tags[soundName]?.filename;
  if (filename != null) {
    return soundManager.isSoundPlaying(filename);
  } else {
    return false;
  }
};

musicManager.playRandomFromArray = function (array) {
  soundManager.play(array[Math.floor(Math.random() * array.length)]);
};

// base

musicManager.fadeLevels = function (
  levels,
  fadeInTime = musicManager._fadeBaseTimeIn,
  fadeOutTime = musicManager._fadeBaseTimeOut,
  volIn,
  volOut
) {
  if (musicManager._returnIdleTimer) {
    musicManager._returnIdleTimer.kill();
    musicManager._returnIdleTimer = undefined;
  }

  if (musicManager._fadeInActive) {
    timerManager.stop(musicManager._fadeInTimer);
    musicManager.fadeLevelsInFinished(musicManager._MAX_MUSIC_VOL);
  }

  if (musicManager._fadeOutActive) {
    timerManager.stop(musicManager._fadeOutTimer);
    musicManager.fadeLevelsOutFinished(volOut);
  }

  // at end as we may not have a channel currently playing - musicManager.basePlaying = levels;
  musicManager._soundsToFadeOut = [];
  musicManager._soundsToFadeIn = [];

  musicManager._fadeInActive = false;
  musicManager._fadeOutActive = false;

  for (let i = 0; i < levels.length; i++) {
    if (musicManager._basePlaying) {
      if (levels[i] === true && musicManager._basePlaying[i] === false) {
        // we want to play but it's currently silent - fade in level
        musicManager._soundsToFadeIn.push(musicManager._baseIDs[i]);
        musicManager._fadeInActive = true;
      } else if (levels[i] === false && musicManager._basePlaying[i] === true) {
        // currently playing but make silent
        musicManager._soundsToFadeOut.push(musicManager._baseIDs[i]);
        musicManager._fadeOutActive = true;
      }
    }
  }

  musicManager._fadeInTimer = timerManager.addTimer(
    fadeInTime,
    musicManager.fadeLevelsIn,
    musicManager.fadeLevelsInFinished(musicManager._MAX_MUSIC_VOL)
  );
  musicManager._fadeOutTimer = timerManager.addTimer(
    fadeOutTime,
    musicManager.fadeLevelsOut,
    musicManager.fadeLevelsOutFinished(volOut)
  );

  musicManager._basePlaying = levels;
};

musicManager.fadeLevelsIn = function (progress) {
  for (let i = 0; i < musicManager._soundsToFadeIn.length; i++) {
    soundManager.setVolume(progress * musicManager._MAX_MUSIC_VOL, musicManager._soundsToFadeIn[i]);
  }
};

musicManager.fadeLevelsOut = function (progress) {
  for (let i = 0; i < musicManager._soundsToFadeOut.length; i++) {
    soundManager.setVolume(
      musicManager._MAX_MUSIC_VOL - progress * musicManager._MAX_MUSIC_VOL,
      musicManager._soundsToFadeOut[i]
    );
  }
};

musicManager.fadeLevelsInFinished = function (volume) {
  for (let i = 0; i < musicManager._soundsToFadeIn.length; i++) {
    soundManager.setVolume(volume, musicManager._soundsToFadeIn[i]);
  }
  musicManager._fadeInActive = false;
};

musicManager.fadeLevelsOutFinished = function (volume) {
  for (let i = 0; i < musicManager._soundsToFadeOut.length; i++) {
    soundManager.setVolume(volume, musicManager._soundsToFadeOut[i]);
  }

  musicManager._fadeOutActive = false;
};

musicManager.fadeBaseMusicOff = function (time = musicManager._fadeBaseTimeOut) {
  musicManager.fadeLevels(musicManager._BASE_ALL_OFF, 0, time, 0, 0);
};

// power

musicManager.fadeLevelsPower = function (
  levels,
  fadeInTime = musicManager._fadeBaseTimeIn,
  fadeOutTime = musicManager._fadeBaseTimeOut,
  volIn,
  volOut
) {
  if (musicManager._returnIdleTimer) {
    musicManager._returnIdleTimer.kill();
    musicManager._returnIdleTimer = undefined;
  }

  if (musicManager._fadeInActive) {
    timerManager.stop(musicManager._fadeInTimer);
    musicManager.fadeLevelsInFinishedPower(musicManager._MAX_MUSIC_VOL);
  }

  if (musicManager._fadeOutActive) {
    timerManager.stop(musicManager._fadeOutTimer);
    musicManager.fadeLevelsOutFinishedPower(volOut);
  }

  // at end as we may not have a channel currently playing - musicManager.powerPlaying = levels;
  musicManager._soundsToFadeOutPower = [];
  musicManager._soundsToFadeInPower = [];

  musicManager._fadeInActivePower = false;
  musicManager._fadeOutActivePower = false;

  for (let i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager._powerPlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager._soundsToFadeInPower.push(musicManager._powerIDs[i]);
      musicManager._fadeInActivePower = true;
    } else if (levels[i] === false && musicManager._powerPlaying[i] === true) {
      // currently playing but make silent
      musicManager._soundsToFadeOutPower.push(musicManager._powerIDs[i]);
      musicManager._fadeOutActivePower = true;
    }
  }

  musicManager._fadeInTimerPower = timerManager.addTimer(
    fadeInTime,
    musicManager.fadeLevelsInPower,
    musicManager.fadeLevelsInFinishedPower(musicManager._MAX_MUSIC_VOL)
  );
  musicManager._fadeOutTimerPower = timerManager.addTimer(
    fadeOutTime,
    musicManager.fadeLevelsOutPower,
    musicManager.fadeLevelsOutFinishedPower(volOut)
  );

  musicManager._powerPlaying = levels;
};

musicManager.fadeLevelsInPower = function (progress) {
  for (let i = 0; i < musicManager._soundsToFadeInPower.length; i++) {
    soundManager.setVolume(progress * musicManager._MAX_MUSIC_VOL, musicManager._soundsToFadeInPower[i]);
  }
};

musicManager.fadeLevelsOutPower = function (progress) {
  for (let i = 0; i < musicManager._soundsToFadeOutPower.length; i++) {
    soundManager.setVolume(
      musicManager._MAX_MUSIC_VOL - progress * musicManager._MAX_MUSIC_VOL,
      musicManager._soundsToFadeOutPower[i]
    );
  }
};

musicManager.fadeLevelsInFinishedPower = function (volume) {
  for (let i = 0; i < musicManager._soundsToFadeInPower.length; i++) {
    soundManager.setVolume(volume, musicManager._soundsToFadeInPower[i]);
  }
  musicManager._fadeInActivePower = false;
};

musicManager.fadeLevelsOutFinishedPower = function (volume) {
  for (let i = 0; i < musicManager._soundsToFadeOutPower.length; i++) {
    soundManager.setVolume(volume, musicManager._soundsToFadeOutPower[i]);
  }

  musicManager._fadeOutActivePower = false;
};

musicManager.fadePowerMusicOff = function (time = musicManager._fadeBaseTimeOut) {
  musicManager.fadeLevelsPower(musicManager._POWER_ALL_OFF, 0, time, 0, 0);
};

// shuffle

musicManager.fadeLevelsShuffle = function (
  levels,
  fadeInTime = musicManager._fadeBaseTimeIn,
  fadeOutTime = musicManager._fadeBaseTimeOut,
  volIn = musicManager._MAX_MUSIC_VOL,
  volOut = 0
) {
  if (musicManager._returnIdleTimer) {
    musicManager._returnIdleTimer.kill();
    musicManager._returnIdleTimer = undefined;
  }

  if (musicManager._fadeInActive) {
    timerManager.stop(musicManager._fadeInTimer);
    musicManager.fadeLevelsInFinishedShuffle(volIn);
  }

  if (musicManager._fadeOutActive) {
    timerManager.stop(musicManager._fadeOutTimer);
    musicManager.fadeLevelsOutFinishedShuffle(volOut);
  }

  // at end as we may not have a channel currently playing - musicManager._shufflePlaying = levels;
  musicManager._soundsToFadeOutShuffle = [];
  musicManager._soundsToFadeInShuffle = [];

  musicManager._fadeInActiveShuffle = false;
  musicManager._fadeOutActiveShuffle = false;

  for (let i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager._shufflePlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager._soundsToFadeInShuffle.push(musicManager._shuffleIDs[i]);
      musicManager._fadeInActiveShuffle = true;
    } else if (levels[i] === false && musicManager._shufflePlaying[i] === true) {
      // currently playing but make silent
      musicManager._soundsToFadeOutShuffle.push(musicManager._shuffleIDs[i]);
      musicManager._fadeOutActiveShuffle = true;
    }
  }

  musicManager._fadeInTimerShuffle = timerManager.addTimer(
    fadeInTime,
    musicManager.fadeLevelsInShuffle,
    musicManager.fadeLevelsInFinishedShuffle(musicManager._MAX_MUSIC_VOL)
  );
  musicManager._fadeOutTimerShuffle = timerManager.addTimer(
    fadeOutTime,
    musicManager.fadeLevelsOutShuffle,
    musicManager.fadeLevelsOutFinishedShuffle(volOut)
  );

  musicManager._shufflePlaying = levels;
};

musicManager.fadeLevelsInShuffle = function (progress) {
  for (let i = 0; i < musicManager._soundsToFadeInShuffle.length; i++) {
    soundManager.setVolume(progress * musicManager._MAX_MUSIC_VOL, musicManager._soundsToFadeInShuffle[i]);
  }
};

musicManager.fadeLevelsOutShuffle = function (progress) {
  for (let i = 0; i < musicManager._soundsToFadeOutShuffle.length; i++) {
    soundManager.setVolume(
      musicManager._MAX_MUSIC_VOL - progress * musicManager._MAX_MUSIC_VOL,
      musicManager._soundsToFadeOutShuffle[i]
    );
  }
};

musicManager.fadeLevelsInFinishedShuffle = function (volume) {
  for (let i = 0; i < musicManager._soundsToFadeInShuffle.length; i++) {
    soundManager.setVolume(volume, musicManager._soundsToFadeInShuffle[i]);
  }
  musicManager._fadeInActiveShuffle = false;
};

musicManager.fadeLevelsOutFinishedShuffle = function (volume) {
  for (let i = 0; i < musicManager._soundsToFadeOutShuffle.length; i++) {
    soundManager.setVolume(volume, musicManager._soundsToFadeOutShuffle[i]);
  }

  musicManager._fadeOutActiveShuffle = false;
};

musicManager.fadeShuffleMusicOff = function (time = musicManager._fadeBaseTimeOut) {
  musicManager.fadeLevelsShuffle(musicManager._SHUFFLE_ALL_OFF, 0, time, 0, 0);
};

//

musicManager.update = function (delta) {
  // Are we playing a sound
  if (musicManager._inPower || musicManager._inShuffle) return;
};

musicManager.onRestorePreviouslyPlayingAudio = function (data) {
  if (data.reason === 'back from replay' && !Reflex.replayGame) {
    // Reset sound ID arrays
    musicManager._baseIDs = [];
    musicManager._powerIDs = [];
    musicManager._shuffleIDs = [];
    // Reset level
    musicManager._basePlaying = musicManager._BASE_ALL_OFF;
    musicManager._powerPlaying = musicManager._POWER_ALL_OFF;
    musicManager._shufflePlaying = musicManager._SHUFFLE_ALL_OFF;
    // Re-initialise sounds
    musicManager.hasInitialised = false;
    musicManager.onGameLoaded();
    musicManager.stopAllTimers();
    musicManager._soundsToFadeIn = [];
    musicManager._soundsToFadeOut = [];
    musicManager._soundsToFadeInPower = [];
    musicManager._soundsToFadeOutPower = [];
    musicManager._soundsToFadeInShuffle = [];
    musicManager._soundsToFadeOutShuffle = [];
  }
};

musicManager.stopAllTimers = function () {
  if (musicManager._returnIdleTimer) {
    musicManager._returnIdleTimer.kill();
    musicManager._returnIdleTimer = undefined;
  }

  if (musicManager._fadeInActive) {
    timerManager.stop(musicManager._fadeInTimer);
    musicManager._fadeInActive = false;
  }

  if (musicManager._fadeOutActive) {
    timerManager.stop(musicManager._fadeOutTimer);
    musicManager._fadeOutActive = false;
  }
};

musicManager.onGoingToReplay = function () {
  musicManager.stopAllTimers();
};

Reflex.addToUpdate(musicManager.update);

Reflex.registerInitialiseManager(musicManager.initialise);

messageBus.subscribe('sounds:restorePreviouslyPlayingAudio', musicManager.onRestorePreviouslyPlayingAudio);
messageBus.subscribe('game:goingToReplay', musicManager.onGoingToReplay);
messageBus.subscribe('sidewinder:XtraPowerTriggerEvent', musicManager.onXtraPowerReady);